import { render, staticRenderFns } from "./FastRecordTicket.vue?vue&type=template&id=390f5780&scoped=true&"
import script from "./FastRecordTicket.vue?vue&type=script&lang=js&"
export * from "./FastRecordTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f5780",
  null
  
)

export default component.exports